import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";
import logo from "../../assets/whiteLogo.png";

function Copyright() {
  return (
    <Typography
      variant="body2"
      color="rgba(255,255,255,0.7)"
      sx={{
        mt: 3,
        pt: 3,
        textAlign: "center",
        fontFamily: "Montserrat",
        fontSize: "14px",
      }}
    >
      © {new Date().getFullYear()} El Deeb UK. All rights reserved.
    </Typography>
  );
}

export default function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: "#164B7C",
        color: "#FFFFFF",
        py: { xs: 4, md: 6 },
        px: { xs: 3, md: 6 },
      }}
    >
      <Box
        sx={{
          maxWidth: "1200px",
          margin: "0 auto",
        }}
      >
        <Grid container spacing={4}>
          {/* Company Info Section */}
          <Grid item xs={12} sm={6} md={3}>
            <Box sx={{ mb: 2 }}>
              <img
                src={logo}
                alt="El Deeb Logo"
                style={{ maxWidth: "150px", height: "auto", marginBottom: "16px" }}
              />
            </Box>
            <Typography
              variant="body2"
              sx={{
                fontFamily: "Montserrat",
                fontSize: "14px",
                lineHeight: 1.6,
                color: "rgba(255,255,255,0.9)",
              }}
            >
              El Deeb for Import,  Export & TA Limited - Your trusted
              partner for medical and commercial product distribution.
            </Typography>
          </Grid>

          {/* Contact Information */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography
              variant="h6"
              sx={{
                fontFamily: "Montserrat",
                fontWeight: 700,
                fontSize: "16px",
                mb: 2,
                color: "#FFFFFF",
              }}
            >
              Contact Us
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
              <Typography
                variant="body2"
                sx={{
                  fontFamily: "Montserrat",
                  fontSize: "14px",
                  color: "rgba(255,255,255,0.9)",
                }}
              >
                15 Poulter Croft, Middleton
                <br />
                Milton Keynes, MK10 9SY
                <br />
                United Kingdom
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  fontFamily: "Montserrat",
                  fontSize: "14px",
                  color: "rgba(255,255,255,0.9)",
                }}
              >
                <Link
                  href="mailto:sales@eldeebco.uk"
                  color="inherit"
                  sx={{
                    textDecoration: "none",
                    "&:hover": {
                      textDecoration: "underline",
                    },
                  }}
                >
                  sales@eldeebco.uk
                </Link>
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  fontFamily: "Montserrat",
                  fontSize: "14px",
                  color: "rgba(255,255,255,0.9)",
                }}
              >
                Mon – Fri, 9 AM – 5 PM (UK Time)
              </Typography>
            </Box>
          </Grid>

          {/* Company Details */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography
              variant="h6"
              sx={{
                fontFamily: "Montserrat",
                fontWeight: 700,
                fontSize: "16px",
                mb: 2,
                color: "#FFFFFF",
              }}
            >
              Company Information
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
              <Typography
                variant="body2"
                sx={{
                  fontFamily: "Montserrat",
                  fontSize: "14px",
                  color: "rgba(255,255,255,0.9)",
                }}
              >
                Company No: 16014927
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  fontFamily: "Montserrat",
                  fontSize: "14px",
                  color: "rgba(255,255,255,0.9)",
                }}
              >
                VAT No: GB 498 0222 75
              </Typography>
            </Box>
          </Grid>

          {/* Social Media & Links */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography
              variant="h6"
              sx={{
                fontFamily: "Montserrat",
                fontWeight: 700,
                fontSize: "16px",
                mb: 2,
                color: "#FFFFFF",
              }}
            >
              Follow Us
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
              <Link
                href="https://www.linkedin.com/company/eldeeb-for-import-export-and-trading-agencies-limited/"
                color="inherit"
                sx={{
                  fontFamily: "Montserrat",
                  fontSize: "14px",
                  textDecoration: "none",
                  color: "rgba(255,255,255,0.9)",
                  "&:hover": {
                    textDecoration: "underline",
                    color: "#FFFFFF",
                  },
                }}
              >
                LinkedIn
              </Link>
              <Link
                href="https://www.instagram.com/eldeeb.co?igsh=MW92MzZkNXp0ZGFkNg=="
                color="inherit"
                sx={{
                  fontFamily: "Montserrat",
                  fontSize: "14px",
                  textDecoration: "none",
                  color: "rgba(255,255,255,0.9)",
                  "&:hover": {
                    textDecoration: "underline",
                    color: "#FFFFFF",
                  },
                }}
              >
                Instagram
              </Link>
              
            </Box>
          </Grid>
        </Grid>

        <Divider
          sx={{
            my: 4,
            borderColor: "rgba(255,255,255,0.2)",
          }}
        />

        {/* Copyright */}
        <Copyright />
      </Box>
    </Box>
  );
}
